/*
  reviewsCarousel:
  This JavaScript function initializes an Alpine.js data object to manage a carousel for displaying customer reviews. It features responsive behavior and autoplay functionality that adjusts based on the viewport size.

  - Returns:
    - An object with methods to initialize, build, and dynamically adjust a review carousel using the Swiper library.

  - Key Features:
    - init: Sets up the carousel, caching necessary DOM nodes and adding event listeners for responsive adjustments.
    - buildSwiper: Constructs the Swiper instance with configurations for autoplay, navigation, and responsive behavior.
    - addResizeListener and removeResizeListener: Manage event listeners for resizing to adjust carousel behavior such as autoplay.
    - adjustAutoplay: Dynamically starts or stops the autoplay feature based on the window's width.
    - destroy: Cleans up by removing event listeners and destroying the Swiper instance to prevent memory leaks.

  This component enhances the user experience by providing a smooth and interactive way to browse customer reviews, with responsiveness and interactivity at its core. It is integrated with Alpine.js for reactivity and efficient DOM updates.
*/

function reviewsCarousel() {
  return {
    swiper: null,
    reviewSwiperLoaded: false,

    init() {
      this.cacheNodes();
      this.buildSwiper();
      this.addResizeListener();
    },

    destroy() {
      this.removeResizeListener();
      if (this.swiper) {
        this.swiper.destroy();
      }
    },

    addResizeListener() {
      this.resizeListener = () => {
        this.adjustAutoplay();
      };
      window.addEventListener('resize', this.resizeListener);
    },

    removeResizeListener() {
      window.removeEventListener('resize', this.resizeListener);
    },

    cacheNodes() {
      this.swiperContainer = document.querySelector('.review-swiper-container');
    },

    buildSwiper() {
      if (this.swiper || !this.swiperContainer) {
        return;
      }
      this.swiper = new Swiper(this.swiperContainer, {
        slidesPerView: 'auto',
        spaceBetween: 16,
        loop: true,
        autoplay: {
          delay: 4000,
          disableOnInteraction: true,
        },
        // pagination: {
        //   el: this.swiperPagination,
        //   clickable: true,
        // },
        navigation: {
          prevEl: '.swiper-button-prev-customer-explorer',
          nextEl: '.swiper-button-next-customer-explorer',
          disabledClass: 'swiper-button-hidden',
        },
        on: {
          init: () => {
            setTimeout(() => {
              this.adjustAutoplay();
            }, 100);
          },
        },
      });
      /* Start pause on hover */
      this.swiperContainer.addEventListener('mouseenter', () => {
        this.swiper.autoplay.stop();
      })
      this.swiperContainer.addEventListener('mouseleave', () => {
        this.swiper.autoplay.start();
      })
      /* End of pause on hover */
      window.addEventListener('resize', () => {
        this.adjustAutoplay();
      });

      this.reviewSwiperLoaded = true;
    },
    
    adjustAutoplay() {
      if (window.innerWidth >= 768) {
        this.swiper.autoplay.start();
      } else {
        this.swiper.autoplay.stop();
      }
    },
  };
}

document.addEventListener('alpine:init', () => {
  Alpine.data('reviewsCarousel', reviewsCarousel);
});
